import { useState } from "react";
import TournamentCard from "./TournamentCard";
import TournamentsFilters from "./TournamentsFilters";
import { getTournamentStatus } from "~/helpers/prepare-tournament-data";
import type { TournamentProps } from "~/helpers/prepare-tournament-data";

const Tournaments: React.FC<{
  tournaments: TournamentProps[];
  showMeta?: boolean;
  asCol?: boolean;
  showFilters?: boolean;
}> = ({
  tournaments,
  showMeta = false,
  asCol = false,
  showFilters = true,
}) => {
  const [selectedGame, setSelectedGame] = useState<string>("all");
  const [selectedTeamSize, setSelectedTeamSize] = useState<string>("any");
  const [selectedStatus, setSelectedStatus] = useState<string>("any");
  return (
    <div>
      {showFilters && (
        <TournamentsFilters
          selectedGame={selectedGame}
          setSelectedGame={setSelectedGame}
          selectedTeamSize={selectedTeamSize}
          setSelectedTeamSize={setSelectedTeamSize}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
        />
      )}
      <div
        className={`flex ${asCol ? "flex-col" : ""} overflow-auto gap-4 mt-4`}
      >
        {tournaments
          .filter(({ gameDetails }) => {
            if (selectedGame !== "all") {
              return gameDetails.id === selectedGame;
            }
            return true;
          })
          .filter(({ teamType }) => {
            if (selectedTeamSize !== "any") {
              return teamType.toLowerCase().includes(selectedTeamSize);
            }
            return true;
          })
          .filter((tournament) => {
            const { tournamentStatus } = getTournamentStatus({
              registeredParticipants: tournament.registeredParticipants,
              matchesPlayed: tournament.matchesPlayed,
              ...tournament.dates,
            });
            if (selectedStatus !== "any") {
              return tournamentStatus === selectedStatus;
            }
            return true;
          })
          .map((tournament) => (
            <TournamentCard
              key={tournament.id}
              tournament={tournament}
              showMeta={showMeta}
              isWide={showMeta}
            />
          ))}
      </div>
    </div>
  );
};

export default Tournaments;
